export default __webpack_public_path__ + "static/hosting-shape5-286f954d10328684fed2cfba5ee4ad30.png";